import { useMemo, useState } from 'react'

import styled from 'styled-components'
import Handle from '~/prix/react/components/handle'
import Modal from '~/prix/react/components/modal'
import { Layer } from '~/packages/general/variable/spaceTime.types'

import SpaceMain from './spaceMain'
import SpaceEdit from './spaceEdit'
import { ToolsAndOptionalResult } from '~/packages/general/variable/tools.typing'
import { WrapperButtons } from '~/components/mapContent/styles/modals'
import { ButtonVariants } from '~/components/buttonVariants'
import { EditSpaceToolProps } from '~/components/mapContent/viewSelect'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 70vh;
  border-radius: inherit;
`

interface ModalSelectSpaceProps {
  layer: Layer
  isOpen: boolean
  onClose: () => void
  onChangeLayer: (layer: Layer | ((oldLayer: Layer) => Layer)) => void
  editProps?: EditSpaceToolProps
  isHighResolutionSpace?: boolean
}

export default function ModalSelectSpace({
  layer,
  isOpen,
  onClose,
  onChangeLayer,
  editProps,
  isHighResolutionSpace = false,
}: ModalSelectSpaceProps) {
  const { spacesLimitation, currentTool } = editProps || {}

  const [currentLayer, setCurrentLayer] = useState<Layer>(layer)

  const isTool = useMemo(() => {
    return !!(layer.variable as ToolsAndOptionalResult).path
  }, [layer])

  const handleCancel = () => {
    onClose()
    setCurrentLayer(layer)
  }

  const handleConfirm = () => {
    onChangeLayer(currentLayer)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Handle>
        <Wrapper>
          {isTool ? (
            <SpaceEdit
              layer={layer}
              currentLayer={currentLayer}
              setCurrentLayer={setCurrentLayer}
              currentTool={currentTool}
              spacesLimitation={spacesLimitation}
              isHighResolution={isHighResolutionSpace}
            />
          ) : (
            <SpaceMain
              layer={layer}
              currentLayer={currentLayer}
              setCurrentLayer={setCurrentLayer}
              isHighResolution={isHighResolutionSpace}
            />
          )}
          <WrapperButtons>
            <ButtonVariants
              onClick={handleCancel}
              label='Cancelar'
              variant='transparent'
              size='sm'
              style={{ height: '30px' }}
            />
            <ButtonVariants
              onClick={handleConfirm}
              label='Confirmar'
              variant='primary'
              size='sm'
              style={{ height: '30px' }}
            />
          </WrapperButtons>
        </Wrapper>
      </Handle>
    </Modal>
  )
}
